import React from 'react';
import Table from 'react-bootstrap/Table';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import { isSeniorStaff } from '../../lib/helper/authorisation';

class HospitalListTable extends React.Component {
  render() {
    const { hospitals = [] } = this.props;
    return (
      <div>
        <Table striped hover responsive className="hospital-list-table mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Bill To Hospital</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {hospitals.map((hospital) => {
              return (
                <tr key={hospital.id}>
                  <td>
                    <Link to={ROUTES.HOSPITALS.SINGLE.replace(':id', hospital.id)} className="text-body">
                      {hospital.name}
                    </Link>
                  </td>
                  <td>
                    {hospital.billToHospital ? (
                      <Link to={ROUTES.HOSPITALS.SINGLE.replace(':id', hospital.billToHospital.id)} className="text-body">
                        {hospital.billToHospital.name}
                      </Link>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                  <td className="text-sm-left text-md-right">
                    <Link to={ROUTES.HOSPITALS.SINGLE.replace(':id', hospital.id)} className="btn btn-sm btn-primary ml-2">
                      {isSeniorStaff() ? 'Edit' : 'View'}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

HospitalListTable.propTypes = {
  hospitals: PropTypes.array.isRequired,
};

export default HospitalListTable;
